/**
 * Shared catalog for Generate Quote and Generate Receipt (Select Packages / Services).
 * Custom entries are stored in localStorage under QUOTE_SERVICES_STORAGE_KEY.
 */

export const QUOTE_SERVICES_STORAGE_KEY = "quoteServices";

/** Default services organized by category (same as original QuoteGenerator list). */
export const DEFAULT_QUOTE_SERVICES = [
  { id: "1", name: "DIGIXLEADS Technical Support", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "2", name: "Construction Duration", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "3", name: "Mobile responsive layouts", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "4", name: "SSL integration support", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "5", name: "Domain 1 Year", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "6", name: "Hosting 1 Year", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "7", name: "Ready in Quick Time Frame", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "8", name: "Link Social Networks", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "9", name: "Website Application", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "10", name: "Social Accounts Creations", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "11", name: "Meta Ads", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "12", name: "Optimization FB & Instagram", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "13", name: "WhatsApp Integration", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "14", name: "Link FB & Instagram", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "15", name: "Designing & Content Updation", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "16", name: "SEO targets keywords", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "17", name: "Daily posting in GMB", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "18", name: "Google Ads (GMB)", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "19", name: "Branding awareness campaigns", category: "Digital Marketing", basePrice: 0, unit: "project", description: "✓" },
  { id: "20", name: "Website", category: "Website & Technical", basePrice: 0, unit: "project", description: "✓" },
  { id: "21", name: "Mobile Application", category: "Mobile Application", basePrice: 0, unit: "project", description: "✓" }
];

export function getDefaultQuoteServiceIds() {
  return new Set(DEFAULT_QUOTE_SERVICES.map((s) => String(s.id)));
}

/** Merge localStorage custom services with defaults (defaults win on same id). */
export function loadAvailableQuoteServices() {
  try {
    const stored = localStorage.getItem(QUOTE_SERVICES_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        const defaultIds = getDefaultQuoteServiceIds();
        const customServices = parsed.filter((s) => !defaultIds.has(String(s.id)));
        return [...DEFAULT_QUOTE_SERVICES, ...customServices];
      }
    }
  } catch (error) {
    console.error("Error loading quote services from localStorage:", error);
  }
  return [...DEFAULT_QUOTE_SERVICES];
}

/** Persist only user-added services (not defaults). */
export function saveCustomQuoteServicesToStorage(availableServices) {
  try {
    const defaultIds = getDefaultQuoteServiceIds();
    const customServices = availableServices.filter((s) => !defaultIds.has(String(s.id)));
    localStorage.setItem(QUOTE_SERVICES_STORAGE_KEY, JSON.stringify(customServices));
  } catch (error) {
    console.error("Error saving quote services to localStorage:", error);
  }
}

/** Build flat service list from API categories (optional future use). */
export function buildServicesFromCategories(categories) {
  if (!Array.isArray(categories) || categories.length === 0) return [];
  const list = [];
  categories.forEach((cat) => {
    const categoryName = cat.category_name || cat.name || "Other";
    (cat.subcategories || []).forEach((sub) => {
      list.push({
        id: String(sub.subcategory_id),
        name: sub.subcategory_name || sub.name || "",
        category: categoryName,
        basePrice: 0,
        unit: "project",
        description: "✓"
      });
    });
  });
  return list;
}
